import * as React from 'react';
import { Typography, Box, List } from '@mui/material';
import { useGetMany } from 'react-admin';
import { CourseCityItem } from './CourseCityItem';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { getUser } from '../../../helper/user';
import { ROLES } from '../../../constants/Roles';
import { isGranted } from '../../../helper/security';

export const CourseCalendarAside = ({ course }) => {
  const user = getUser();
  const canCourseCreatorManageDates =
    user?.roles?.includes(ROLES.ROLE_COURSE_CREATOR) &&
    (
      course.editableByCourseCreator ||
      (
        course.createdByEmail === user.username &&
        !course.enabled
      )
    );
  const canDeleteDates =
    isGranted(ROLES.ROLE_ADMIN, user) || canCourseCreatorManageDates;
  const canEditDates =
    isGranted(ROLES.ROLE_ADMIN, user) || canCourseCreatorManageDates;
  const canEditPublishedDates =
    isGranted(ROLES.ROLE_ADMIN, user) ||
    (
      user?.roles?.includes(ROLES.ROLE_COURSE_CREATOR) &&
      course.editableByCourseCreator
    );
  const { data, isLoading, error } = useGetMany('course_cities', {
    ids: course.courseCities,
  });

  if (isLoading || !data) {
    return null;
  }

  if (error) {
    return <p>ERROR</p>;
  }

  const renderIcon = () => {
    return course.drupalId === null ? (
      <CloseIcon fontSize={'small'} color={'error'} />
    ) : (
      <CheckIcon fontSize={'small'} color={'success'} />
    );
  };

  return (
    <Box sx={{ width: '33%', margin: '1em', mt: '0' }}>
      <Typography variant="h5" sx={{ pl: 2 }}>
        {course.code} {renderIcon()}
      </Typography>
      <List aria-labelledby="nested-list-subheader">
        {data.map((e) => (
          <CourseCityItem
            key={e['@id']}
            cc={e}
            canDeleteDates={canDeleteDates}
            canEditDates={canEditDates}
            canEditPublishedDates={canEditPublishedDates}
          />
        ))}
      </List>
    </Box>
  );
};
